import {memo} from 'react';

import {type Channel} from 'mattermost-redux/types/channels';
import {type Post} from 'mattermost-redux/types/posts';

import CreateComment from '../threading/virtualized_thread_viewer/create_comment';

import RhsHeaderPost from 'components/rhs_header_post';
import ThreadViewer from 'components/threading/thread_viewer';
import {VirtualizedContextProvider} from 'components/threading/virtualized_thread_viewer/virtualized_context';

import styles from './rhs_thread.module.css';

type Props = {
    posts: Post[];
    channel: Channel | null;
    selected: Post;
    previousRhsState?: string;
}

const RhsThread = ({
    selected,
    posts,
    channel,
    previousRhsState,
}: Props) => {
    if (posts == null || selected == null || !channel) {
        return (
            <div/>
        );
    }

    return (
        <div id='rhsContainer' className='sidebar-right__body'>
            <VirtualizedContextProvider>
                <RhsHeaderPost
                    rootPostId={selected.id}
                    channel={channel}
                    previousRhsState={previousRhsState}
                />
                <ThreadViewer
                    rootPostId={selected.id}
                    useRelativeTimestamp={false}
                />
                <div className={styles.editorContainer}>
                    <CreateComment
                        focusOnMount={true}
                        rootId={selected.id}
                        isThreadView={false}
                        threadId={selected.id}
                    />
                </div>
            </VirtualizedContextProvider>
        </div>
    );
};

export default memo(RhsThread);
